

import {
SaafHeader,
SaafScroller,
} from '@/common/components/index'
import { mapState } from 'vuex'

import {service,nativeApi} from '@/common/index'
import {fetch} from '@/page/index'


export default {
data () {
return {
viewHeight: service.getViewHeight(service.componentHeight().native),
page: service.pageServer.newPage(),
list:[],
}
},
components: {
SaafHeader,
SaafScroller,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
}),
},
created(){

},
activated:function(){
this.findList()
},
methods: {
findList(p){
if (p === 0) {
this.$refs.SaafScroller.scrollTo(0,0,0)
this.page = service.pageServer.newPage()
}
this.params = {
}
fetch.baseLookupTypeService_find({
params: this.params,
pageRows: this.page.pageSize,
pageIndex: this.page.nextIndex
}).then(res=>{
this.page = service.pageServer.update(this.page, res)
if (p === 0) {
this.list = res.data
} else {
this.list = this.list.concat(res.data)
}
this.$refs.SaafScroller.scrollUpdate()
}).catch(err=>{
this.$refs.SaafScroller.scrollUpdate()
})
},
},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/devDemo2/demoPage2.vue